import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../../helpers/bgSliders";
import "./SignupPage.scss";
import StcSignupPageDisplay from "./SignupPage.styled";
import { setLoginData } from "../../../helpers/helpers";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { setAgencyData, saveTracker } from "../../../helpers/agencyTracker";
import queryString from "query-string";
import * as localLang from "../../../i18n/i18n";
import { subscribe } from "../NcellSignupPage/services";


const randomBg = bgSliders.getRandomBg();
function StcSignupPage({ t, i18n }) {
   const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    
    // Optional: Update URL without reload
    const newUrl = `${window.location.pathname}?lang=${lng}`;
    window.history.pushState({}, '', newUrl);
  };
  const [activeData, setActiveData] = useState("");
  const [transactionidentify,setTransactionidentify] = useState("");
  const [checkPhone, setCheckPhone] = useState(false);

  const [showverif, setShowverif] = useState(false);
  const [showSms, setShowSMS] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [errorMesg, setErrorMesg] = useState(false);
  const [verfiErrorMesg, setVerfiErrorMesg] = useState(false);
  const [errorresverify, seterrorresverify] = useState("");

  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [showLoading, setshowLoading] = useState(false);



  const history = useHistory();
  const [alert, setAlert] = useState(false);




  useEffect(() => {
  
    const params = queryString.parse(window.location.search);
    if (params.lang) {
      localStorage.setItem("i18nextLng", params.lang);
      if(localStorage.getItem("i18nextLng") != params.lang){
        localStorage.setItem("i18nextLng", params.lang);
        window.location.reload();
      }
     
    }

    const urlsearch = window.location.search;
    if (urlsearch !== "") {
      setAgencyData(urlsearch);
    }
  });



    const Subscribe = async (e) => {
      e.preventDefault();
      if (!activeData) {
        setErrorMesgSubscribe("Phone number is required.");
        setErrorMesg(true);
        return;
      } 
      const phon_n = activeData.toString();
        const url = `https://vas2.grand-hub.com/api/playIt/stc-d/he?phone=${phon_n}`;
        setshowLoading(true);
        try {
          const res = await axios.get(url);
          if (res.data.success) {
          window.location.href = res.data.url;
          
          } else {
            setErrorMesgSubscribe(res.data.message || "برجاء ادخال رقم STC صحيح");
            setErrorMesg(true);
          }
        } catch (error) {
          setErrorMesgSubscribe(error.error.message);
          setErrorMesg(true);
        } finally {
          setshowLoading(false);
        }
      
    };






  return (
    <StcSignupPageDisplay className="">
      {alert && (
        <FloatingAlert type={"danger"}>
          In order to signup please turn your mobile data.
        </FloatingAlert>
      )}

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

      {verfiErrorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorresverify}</Trans>
        </FloatingAlert>
      ) : null}

      <div className='operatorSignup'>
        <div className="formsLayout formsLayoutjawal">

          <div className='header header_gamezone d-flex justify-content-between align-items-center'>
            <Link to="/">
              <div className='logo logo gamezoneLogo' />
            </Link>
             <div className="language-switcher">
            <button
              onClick={() => changeLanguage('en')}
              className={i18n.language === 'en' ? 'active' : ''}
            >
              EN
            </button>
            <button
              onClick={() => changeLanguage('ar')}
              className={i18n.language === 'ar' ? 'active' : ''}
            >
              AR
            </button>
          </div>
          </div>
          
          {!showverif ?
            <div className="links-Section links-Sectionjawwalgamezorid">

             
              <div className="play"></div>
                        <p>{t("subscribe_msg")} </p>    
                        <p className="my-2">{t("subscribe_msg2")} </p>    

      <form
        name="formsubmit"
        className="stc-form-wrap"
        onSubmit={(e) => {
          e.preventDefault();
          Subscribe(e);
        }}
      >
        <div className="stc-phone-row">
          <input
            type="text"
            className="input gamezoneInput gamezonekeyph"
            value="+966"
            disabled
            readOnly
            aria-label="Country code"
          />
          <input
            type="tel"
            className="input gamezoneInput gamezonenumph"
            placeholder="XX XXX XX XX"
            name="phone_number"
            value={activeData}
            autoComplete="tel"
            disabled={checkPhone === true || showLoading}
            onChange={(e) =>
              setActiveData(e.target.value.replace(/[^0-9]/g, ""))
            }
          />
        </div>
        <button
          id="signupbut"
          className="btn stc-subscribe-btn"
          type="submit"
          disabled={!activeData || showLoading}
        >
          {showLoading ? t("loading") : t("Subscribe")}
        </button>
      </form>


              <div className="row text-center" >
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>98%</span><img src="/assets/images/subscribegamezriod/like.png" alt="img" className="iconsimg" />
                    <p><Trans>evaluation</Trans></p>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>1000+</span><img src="/assets/images/subscribegamezriod/Repeat.png" alt="img" className="iconsimg" />
                    <p><Trans>game</Trans></p>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>500k+</span><img src="/assets/images/subscribegamezriod/group.png" alt="img" className="iconsimg" />
                    <p><Trans>user</Trans></p>
                  </div>
                </div>
              </div>


              <div className="footer jawwalgamezoridFooter zainiqFooter">
                {!showverif ? "" : null}
                <div className="ncellTos jawwalgamezoridncellTos">
                  <p style={{lineHeight:"1.2",margin:"0 0 5px 0"}}><Trans>ksa_stc</Trans></p>
                 
                </div>
              </div>
            </div>

            : null}

         

          {showLoading ?
            <div className="load">
              <div className="spinerC">
                <div className="spinner"></div>
              </div>
            </div>
            : null}




        </div>
      </div>

      
    </StcSignupPageDisplay>
  );
}
export default withTranslation()(StcSignupPage)
